import React, { useState, useRef } from "react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import fr from "suneditor/src/lang/fr.js";
import { Button, message } from "antd";
import { SaveOutlined } from "@ant-design/icons";
import axios from "axios";
import { useSelector } from "react-redux";
import Page404 from "app/not-found";

const API_URL = process.env.REACT_APP_API_URL;

const PageAjouterProjet = () => {
  const { user } = useSelector((state) => state.user);

  const [nom, setNom] = useState("");
  const [descriptionCourte, setDescriptionCourte] = useState("");
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");
  const [cout, setCout] = useState("");
  const [descriptionHtml, setDescriptionHtml] = useState("");

  const editorRef = useRef(null);

  // === IMAGE UPLOAD SUNEDITOR (serveur) ===
  const onImageUploadBefore = async (files, info, uploadHandler) => {
    const file = files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file); // serveur attend "image"

    try {
      const res = await axios.post(`${API_URL}/api/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // serveur renvoie { url: "..." }
      uploadHandler({
        result: [
          {
            url: res.data,
            name: file.name,
            size: file.size,
          },
        ],
      });
    } catch (err) {
      console.error(err);
      message.error("Erreur upload image");
    }
  };

  // === SAVE PROJET ===
  const handleSave = async () => {
    const hasContent =
      descriptionHtml.replace(/<(.|\n)*?>/g, "").trim() !== "" ||
      /<img[\s\S]*?>/i.test(descriptionHtml);

    if (
      !nom.trim() ||
      !descriptionCourte.trim() ||
      !dateDebut ||
      !dateFin ||
      !cout ||
      !hasContent
    ) {
      message.error("Tous les champs sont obligatoires");
      return;
    }

    try {
      await axios.post(`${API_URL}/api/projets`, {
        nom,
        auteur: user._id,
        descriptionCourte,
        dateDebut,
        dateFin,
        cout: Number(cout),
        html: descriptionHtml,
      });

      message.success("Projet enregistré avec succès");
      window.location.reload();
    } catch (err) {
      console.error(err);
      message.error("Erreur lors de l’enregistrement du projet");
    }
  };

  if (!user) return <Page404 />;

  return (
    <div className="max-w-4xl mx-auto p-4">
      <h1 className="text-center text-3xl font-bold mb-6">
        Nouveau projet
      </h1>

      <div className="space-y-4">
        <div className="flex flex-col">
          <label className="font-bold mb-1">Nom du projet</label>
          <input
            type="text"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            className="w-full border rounded px-2 py-1.5"
          />
        </div>

        <div className="grid grid-cols-3 gap-x-4">
          <div className="flex flex-col">
            <label className="font-bold mb-1">Date début</label>
            <input
              type="date"
              value={dateDebut}
              onChange={(e) => setDateDebut(e.target.value)}
              className="border rounded px-2 py-1.5"
            />
          </div>

          <div className="flex flex-col">
            <label className="font-bold mb-1">Date fin</label>
            <input
              type="date"
              value={dateFin}
              onChange={(e) => setDateFin(e.target.value)}
              className="border rounded px-2 py-1.5"
            />
          </div>

          <div className="flex flex-col">
            <label className="font-bold mb-1">Coût</label>
            <input
              type="number"
              value={cout}
              onChange={(e) => setCout(e.target.value)}
              className="border rounded px-2 py-1.5"
            />
          </div>
        </div>

        <div className="flex flex-col">
          <label className="font-bold mb-1">Description courte</label>
          <input
            type="text"
            value={descriptionCourte}
            onChange={(e) => setDescriptionCourte(e.target.value)}
            className="w-full border rounded px-2 py-1.5"
          />
        </div>
      </div>

      <div className="mt-6">
        <label className="font-bold block mb-2">Description</label>
        <SunEditor
          ref={editorRef}
          lang={fr}
          setOptions={{
            height: "500px",
            buttonList: [
              ["undo", "redo"],
              ["bold", "underline", "italic", "strike"],
              ["fontColor", "hiliteColor"],
              ["align", "list"],
              ["link", "image", "video"],
              ["table"],
              ["codeView"],
            ],
          }}
          onChange={setDescriptionHtml}
          onImageUploadBefore={onImageUploadBefore} // upload vers serveur
        />
      </div>

      <div className="mt-6">
        <Button
          type="primary"
          icon={<SaveOutlined />}
          onClick={handleSave}
        >
          Enregistrer le projet
        </Button>
      </div>
    </div>
  );
};

export default PageAjouterProjet;
